var map = {
	"./white/0.25.svg": 750,
	"./white/0.5.svg": 751,
	"./white/0.75.svg": 752,
	"./white/0.svg": 753,
	"./white/1.svg": 754,
	"./white/10.svg": 755,
	"./white/11.svg": 756,
	"./white/2.svg": 757,
	"./white/3.svg": 758,
	"./white/4.svg": 759,
	"./white/5.svg": 760,
	"./white/6.svg": 761,
	"./white/7.svg": 762,
	"./white/8.svg": 763,
	"./white/9.svg": 764,
	"./yellow/0.25.svg": 765,
	"./yellow/0.5.svg": 766,
	"./yellow/0.75.svg": 767,
	"./yellow/0.svg": 768,
	"./yellow/1.svg": 769,
	"./yellow/10.svg": 770,
	"./yellow/11.svg": 771,
	"./yellow/2.svg": 772,
	"./yellow/3.svg": 773,
	"./yellow/4.svg": 774,
	"./yellow/5.svg": 775,
	"./yellow/6.svg": 776,
	"./yellow/7.svg": 777,
	"./yellow/8.svg": 778,
	"./yellow/9.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 749;